<template>
  <div class="clipboard">
    <div v-if="isLoading" class="loader-layer">
      <div class="spinner">
        <loading-spinner :size="48" />
      </div>
    </div>

    <div v-if="isPlaceholderLoading" class="clipboard__placeholder">
      <div class="spinner mb-24">
        <loading-spinner :size="48" />
      </div>
      <p class="font-22">Ładowanie ofert...</p>
    </div>

    <div
      v-if="!isPlaceholderLoading && ilofert == 0"
      class="clipboard__placeholder"
    >
      <div class="mb-8">
        <svg
          class="svg-icon"
          style="width: 86px; height: 86px; vertical-align: middle"
          viewBox="0 0 1024 1024"
          xmlns="http://www.w3.org/2000/svg"
          fill="#cccccc"
          overflow="hidden"
        >
          <path
            d="M957.12 297.02c0-.12 0-.19.06-.25.52-.9.9-1.8 1.22-2.75.26-.52.45-.96.64-1.35.26-.77.26-1.4.45-2.11.19-.83.38-1.54.45-2.24.06-.45 0-.83 0-1.22.06-1.15.12-2.17 0-3.26-.07-.51-.2-1.02-.32-1.54-.13-.9-.26-1.85-.52-2.81-.12-.45-.38-.83-.5-1.28a23.4 23.4 0 0 0-1.16-2.95c0-.06-.06-.12-.06-.19-.26-.45-.52-.83-.84-1.28-.5-.77-.96-1.6-1.53-2.3-.51-.64-1.09-1.22-1.6-1.73s-.96-1.02-1.47-1.47c-.77-.64-1.6-1.22-2.5-1.73-.38-.2-.64-.51-1.02-.7l-.39-.2s-.06 0-.13-.06L676.16 112.9c-.13-.07-.26-.13-.45-.26-.7-.32-1.34-.58-2.05-.9s-1.47-.64-2.24-.9c-.44-.12-.9-.18-1.34-.25a16.82 16.82 0 0 0-3-.64h-1.03a20.02 20.02 0 0 0-3.4.07c-.44.06-.89.19-1.27.25-1.03.13-1.99.32-3.08.64l-1.4.58c-.96.38-1.8.7-2.76 1.21l-.38.2L512 192.2l-141.76-79.3-.38-.2c-.9-.5-1.86-.76-2.76-1.15-.44-.19-.9-.38-1.4-.57a18.89 18.89 0 0 0-3.2-.64c-.32-.07-.7-.2-1.1-.26a22.48 22.48 0 0 0-3.58-.06h-.76c-1.16.12-2.24.32-3.33.64-.39.12-.7.12-1.03.19-.9.32-1.66.7-2.56 1.09-.57.12-1.21.38-1.79.7-.13.06-.32.13-.51.26L76.04 265.6l-.4.2c-.44.25-.76.57-1.08.82a15.4 15.4 0 0 0-2.5 1.67l-1.53 1.53c-.51.58-1.09 1.1-1.54 1.67-.64.7-1.09 1.6-1.6 2.37-.25.44-.57.76-.77 1.15-.06.06-.06.19-.06.25-.51.9-.83 1.86-1.15 2.76-.2.5-.45.96-.58 1.47-.25.7-.32 1.47-.45 2.3-.12.7-.32 1.35-.38 2.05v1.8c0 .89-.06 1.72 0 2.62.06.57.26 1.21.38 1.79.13.9.26 1.73.52 2.56.25.51.44.9.64 1.4.38.97.76 1.93 1.21 2.76 0 .06.07.13.07.25.12.13.32.26.38.52.83 1.34 1.8 2.62 2.88 3.77.38.39.77.77 1.22 1.15.96.9 2.04 1.67 3.2 2.5.38.26.76.58 1.21.83.2.13.32.13.39.2l122.04 64.57-106.04 51.2c-.39.13-.77.45-1.16.64-.76.45-1.47.83-2.1 1.34-.65.39-1.16.9-1.74 1.41s-1.15.96-1.6 1.54c-.57.64-1.08 1.34-1.6 1.92-.32.38-.64.7-.9 1.09-.12.06-.18.32-.31.5-.39.71-.77 1.48-1.15 2.12-.32.7-.64 1.34-.9 1.92-.26.7-.38 1.34-.64 2.05-.13.9-.32 1.53-.45 2.3s-.13 1.41-.19 2.05c-.06.83-.13 1.6-.13 2.24 0 .83.13 1.47.26 2.18.06.76.19 1.6.32 2.3.13.64.32 1.22.57 1.92.26.83.52 1.6.9 2.37.06.25.13.38.2.64.12.19.31.38.44.64.83 1.4 1.66 2.88 2.82 4.16.25.25.44.64.76.9a29.55 29.55 0 0 0 3.97 3.45l137.22 91.14c-.39 1.6-.64 3.32-.64 5.05v135.55c0 .39.13.77.13 1.16.06 1.15.12 2.24.32 3.26.12.77.38 1.34.64 2.11.19.77.38 1.35.64 2.11.25.77.64 1.35.96 1.99.32.64.64 1.34 1.08 1.98.39.64.9 1.15 1.35 1.73.51.51.9 1.15 1.4 1.73.77.64 1.6 1.34 2.44 1.98.38.26.64.64 1.02.77l.07.13L499.07 891.9v.13c.45.26 1.03.51 1.54.77.51.38 1.02.64 1.47.9.83.38 1.66.76 2.56 1.02.38.13.83.26 1.28.38.32.13.64.26.96.26 1.66.38 3.33.64 5.06.64v.13c.06-.13.06-.26.06-.26 1.73 0 3.4-.25 5-.64.38 0 .63-.13 1.02-.25.44-.13.9-.26 1.28-.39.9-.25 1.72-.64 2.5-1.02.5-.26 1.02-.51 1.46-.77.52-.38 1.1-.64 1.48-.9.06 0 .12 0 .12-.12l262.98-179.9c.45-.26.77-.65 1.15-.9.77-.64 1.6-1.28 2.24-1.86.58-.64 1.03-1.28 1.47-1.73.39-.64.9-1.15 1.35-1.73.38-.64.7-1.34 1.02-1.98a13.63 13.63 0 0 0 1.73-4.1c.2-.76.45-1.34.58-2.1.25-1.16.32-2.25.38-3.4 0-.26.13-.64.13-1.02V557.57c0-1.73-.26-3.46-.64-5l137.28-91.2a33.6 33.6 0 0 0 3.97-3.39c.25-.32.44-.7.7-.96a22.98 22.98 0 0 0 2.88-4.16c.13-.19.26-.38.38-.64.13-.19.13-.38.26-.57.38-.83.64-1.6.9-2.43.25-.7.38-1.28.64-1.86.12-.77.25-1.47.25-2.3.13-.7.26-1.35.26-2.12s0-1.47-.07-2.24-.06-1.34-.19-2.1c-.13-.71-.38-1.42-.51-2.12-.26-.77-.38-1.47-.7-2.18-.26-.64-.58-1.21-.84-1.79-.38-.83-.76-1.53-1.28-2.3-.12-.13-.12-.39-.25-.51-.26-.39-.64-.7-.9-1.03-.51-.7-1.02-1.34-1.6-1.98a11.48 11.48 0 0 0-1.6-1.47 11.88 11.88 0 0 0-1.73-1.41 11.9 11.9 0 0 0-2.24-1.41c-.38-.2-.76-.58-1.15-.7l-105.98-51.2 121.98-64.52c.13-.12.26-.12.39-.25l1.15-.77c1.28-.83 2.37-1.6 3.39-2.62a18.62 18.62 0 0 0 4.03-5c.2-.06.32-.19.45-.32zM664.83 585.6l-108.1-70.53 218.89-117.95 100.1 48.32L664.82 585.6zm-305.66 0L148.22 445.44l100.1-48.32L467.2 515.07 359.17 585.6zm-.13-426.5 106.69 59.78-217.35 126.4-113.72-60.1L359.04 159.1zM512 487.23 295.8 370.7 512 245.06l216.26 125.63L512 487.23zm46.2-268.41 106.7-59.78 224.44 126.08-113.66 60.1-217.47-126.4zm-211.83 413.3c.25.14.57.26.9.4 1.27.76 2.55 1.34 3.96 1.85.58.25 1.15.51 1.86.77 1.85.5 3.77.76 5.7.76.06 0 .12.13.25.13.06 0 .13-.13.26-.13 1.92 0 3.84-.25 5.7-.76.63-.26 1.2-.52 1.78-.77a19.63 19.63 0 0 0 3.97-1.73l.83-.38 117.57-76.74v274.11L271.87 681.15v-98.5l74.5 49.48zm405.76 49.03L534.85 829.63V555.52l117.57 76.74c.32.12.57.25.83.38 1.28.77 2.62 1.34 3.97 1.86.64.12 1.15.38 1.72.64 1.86.5 3.84.76 5.76.76.07 0 .13.13.26.13 0 0 .06-.13.13-.13 1.98 0 3.97-.25 5.89-.9a6.9 6.9 0 0 0 1.72-.63 25.1 25.1 0 0 0 3.97-1.86c.32-.25.64-.25.9-.38l74.56-49.47v98.5z"
          />
        </svg>
      </div>
      <p class="font-22">Twój schowek na oferty jest pusty.</p>
      <a href="/">Strona główna</a>
    </div>

    <a-row :gutter="[24, 32]" type="flex">
      <a-col
        v-for="(item, idx) in oferty"
        :key="idx"
        :xs="24"
        :sm="12"
        :md="24"
      >
        <T1ClipboardOfferCard
          :isMobile="isMobile"
          :comparisionLink="getCompareLink()"
          :comparisionItems="comparison"
          :oferta="getOfertyItems(idx)"
          :key="componentKey"
          @offerRemove="offerRemove"
        />
      </a-col>
    </a-row>

    <div
      v-if="isMobile"
      class="clipboard__floating-bar"
      :class="{ visible: compareValid() }"
    >
      <div class="container">
        <div class="clipboard__compare-tools">
          <span @click="clearSelected()" class="mr-32">Wyczyść</span>
          <a :href="getCompareLink()" class="btn btn-md btn-green"
            >Porównaj
            <span class="d-none d-xs-inline">zaznaczone oferty</span> ({{
              comparison.length
            }}/4)</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import T1VarLoader from "./T1VarLoader";
import T1ClipboardOfferCard from "./T1OfferCards/T1ClipboardOfferCard";

let xml2js = require("xml2js");

export default {
  name: "clipboard-offers",
  data: () => ({
    isLoading: false,
    isPlaceholderLoading: true,
    oferty: [],
    offersReady: false,
    ilofert: 0,
    comparison: [],
    isMobile: false,
    componentKey: 0,
    schowek_offers: [],
    window: {
      width: 0,
    },
  }),
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    getCompareLink() {
      if (this.comparison.length > 1) {
        return "/oferta/schowek-compare.xml?kodId=" + this.comparison.join(",");
      }
    },
    compareValid() {
      if (this.comparison.length > 1 && this.comparison.length < 5) {
        return true;
      } else {
        return false;
      }
    },
    getOfertyItems(i) {
      return this.oferty[i];
    },
    clearSelected() {
      this.comparison = [];
    },
    getFromDate(data) {
      if (data != null && data != "" && data.length >= 8) {
        return data.substring(4, 6) + data.substring(6);
      } else {
        return "";
      }
    },
    getHref(hurl) {
      if (hurl != null && hurl != "") {
        return hurl;
      } else {
        return "/hotele/hotel.xml";
      }
    },

    getUrlOferta(oferta, href) {
      let lparams = this.$route.query;
      let adt = 2;
      let chd = 0;
      let inf = 0;
      let chage = "";
      if (lparams["adt"]) {
        adt = Number(lparams["adt"]);
      }
      if (lparams["chd"]) {
        chd = Number(lparams["chd"]);
      }
      if (lparams["inf"]) {
        inf = Number(lparams["inf"]);
      }
      if (lparams["chage"]) {
        chage = lparams["chage"];
      }
      //let link = 'https://www.wyspykanaryjskie.pl/merlinobiektmds-param.xml?xCode=' + oferta.ofr.obj.xCode + '&tourOp=' + oferta.ofr.tourOp + '&htlCode=' + oferta.ofr.obj.code + '&kodId=' + oferta.ofr.id;
      let link =
        (href === undefined ? this.getHref(oferta.ofr.hurl) : "") +
        "?xCode=" +
        oferta.ofr.obj.xCode +
        "&tourOp=" +
        oferta.ofr.tourOp +
        "&htlCode=" +
        oferta.ofr.obj.code +
        "&kodId=" +
        oferta.ofr.id;
      link += "&adt=" + adt;
      if (chd > 0) {
        link += "&chd=" + chd;
      }
      if (chage != "") {
        link += "&chage=" + chage;
      }
      if (inf > 0) {
        link += "&inf=" + inf;
      }
      let fromDate = this.getFromDate(oferta.ofr.trp.startDate);
      if (fromDate != "") {
        link += "&fromDate=" + fromDate;
      }
      return link;
    },
    getWyzywienie(numer) {
      return this.wyzyw[numer];
    },
    getTourop(tourop) {
      let tourOpName;
      if (tourop != null && tourop != "") {
        let items = this.tourop;
        items.forEach(function (obj) {
          if (obj.kod == tourop) {
            tourOpName = obj.nazwa;
          }
        });
        return tourOpName;
      } else {
        return "";
      }
    },
    offerRemove(oferta) {
      this.isLoading = true;
      let that = this;
      let offerId = oferta.ofr.id;
      let offerRemoveUrl =
        "https://www.travelone.pl/oferta/schowek.xml" +
        this.getUrlOferta(oferta, true) +
        "&oper=del";

      if (this.schowek_offers instanceof Array) {
        if (this.schowek_offers.includes(offerId)) {
          const index = this.schowek_offers.indexOf(offerId);

          if (index > -1) {
            this.schowek_offers.splice(index, 1);
          }
        }
      }

      if (window.localStorage && localStorage.getItem("t1uid")) {
        let offers = localStorage.getItem("t1offers").split(",");
        if (offers.includes(offerId)) {
          const index = offers.indexOf(offerId);
          if (index > -1) {
            offers.splice(index, 1);
          }
        }
        localStorage.setItem("t1offers", offers);
      }
      localStorage.setItem("t1needsync", 1);

      let indeks = offerRemoveUrl.indexOf("?");
      let oper = offerRemoveUrl.substring(indeks);

      if (indeks > 0) {
        T1VarLoader.loadSchowekOffers(oper).then((data) => {
          let xmlObj = jQuery(data);
          let ileofert = xmlObj.find("offer").length;
          that.$root.$emit("clipboardCounter", ileofert);
          that.$emit("clipboardCounter", ileofert);

          that.oferty.forEach(function (obj) {
            if (obj.ofr.id == offerId) {
              that.oferty.splice(that.oferty.indexOf(obj), 1);
            }
          });

          that.ilofert = ileofert;
          this.isLoading = false;
          this.forceRerender();
        });
      }
      return false;
    },
    processResult(result) {
	var that = this;
        if (result.Page && result.Page.ilofert) {
              var ilofert = Number(result.Page.ilofert);
              console.log("Znaleziono: " + ilofert + " ofert");
              that.ilofert = ilofert;
              that.$root.$emit("clipboardCounter", ilofert);
              that.$emit("clipboardCounter", ilofert);

              if (ilofert > 0) {
                for (let i in result.Page.page["0"].offer) {
                  var current = result.Page.page["0"].offer[i];
                  var ofr = current.MDSDetails["0"].ofr["0"].$;
                  var obj = current.MDSDetails["0"].ofr["0"].obj["0"].$;
                  var trp = current.MDSDetails["0"].ofr["0"].trp["0"].$;
                  var noffer = {};
                  noffer.ofr = ofr;
                  noffer.ofr.obj = obj;
                  noffer.ofr.trp = trp;
                  that.oferty.push(noffer);
                  that.schowek_offers.push(ofr.id);
                }
              }
              that.offersReady = true;
              that.isPlaceholderLoading = false;
	}
    },
    loadSchowekOffers() {
      var that = this;
      if (window.localStorage && (localStorage.getItem("schowek") != null)) {
	console.log("LocalStorage with Schowek offers found.");
	var result = JSON.parse(localStorage.getItem("schowek"));
	that.processResult(result);
      } else {
        T1VarLoader.loadSchowekOffers().then((data) => {
	var result = JSON.parse(localStorage.getItem("schowek"));
	that.processResult(result);
        });
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      if (window.innerWidth < 992) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize, { passive: true });
    this.handleResize();
  },
  mounted() {
    let that = this;

    // this.$nextTick(() => {
    this.loadSchowekOffers();
    // });
    this.$root.$on("update:comparisons", (val) => {
      if (val != null) {
        if (!that.comparison.includes(val)) {
          that.comparison.push(val);
        } else {
          let ind = that.comparison.indexOf(val);
          that.comparison.splice(ind, 1);
        }
      }
    });
  },
  components: {
    T1ClipboardOfferCard,
  },
};
</script>

<style lang="scss" scoped>
.clipboard {
  margin-bottom: 112px;
  min-height: 450px;

  &__floating-bar {
    background-color: #fff;
    box-shadow: 0 0 4px 2px rgba($gray-50, 0.25);
    display: flex;
    align-items: center;
    height: 58px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: -58px;
    transition: bottom 0.1s linear;
    z-index: 9;

    &.visible {
      bottom: 0;
    }
  }

  &__compare-tools {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 450px;
  }
}

.spinner {
  width: 48px;
  height: 48px;
  position: relative;
}

.loader-layer {
  background-color: rgba(#ffffff, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
}
</style>
